module.exports = __webpack_public_path__ + "img/mboa_cov_logo.565b63d9.png";